import api from '@/shared/api/base-api'
import { IShipper } from '../model/types'

export const getShipperById = (id: string) =>
  api.get<IShipper>(`/v1/shippers/${id}`)
